$(document).ready(function() {
console.info('Quiz Ready!');


	// CAROL

	var $status = $('.quizstatus');
	var $slickElement = $('.quizcarol');
	// HIDE CONTINUE BUTTON
	 // $('.quizcont').hide();
	 // $('.quizcont').css('visibility', 'hidden');

	// ADD CONT BUTTON IF CHECKED
setTimeout(function() {
	var firstslide = $(".slick-slide[data-slick-index='0']");
	console.log(firstslide)
	var firstinput = firstslide.find('input');
	if (firstinput.length > 0) {
		firstinput.on('click', function() {
				$('.quizcont').css('display', 'flex').css('visibility', 'visible');
		});
	}
			if (firstinput.is(':checked')) {
				console.info("im first checked");
				$('.quizcont').css('display', 'flex').css('visibility', 'visible');
			}
			else {
				$('.quizcont').css('visibility', 'hidden');
			}
}, 800);



	// SETS STATS OF QUIZ / x of x
	$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $status.text('Q '+ i + '/' + slick.slideCount);

	});

	$slickElement.on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
		$('.quizcont').css('visibility', 'hidden');
	});




	// PREVE AND NEXT BARS
	$slickElement.on('afterChange', function(event, slick, currentSlide, nextSlide){
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    console.info('Current-slide '+ i);
	    var dataslide = $('.quizbars').find('[data-slidebar='+i+']');
	    					var dataslidebar = dataslide.data('slidebar');
	    					 $('.singlebar').each(function() {
	    							$(this).removeClass('is-active')
	    					 });

	    					if (dataslidebar == i) {
	    						dataslide.addClass('is-active');
	    					 }

	    					  // ADD CONT BUTTON IF CHECKED
	    					 var thisslide = $('.slick-slide.slick-active');
	    					 $('.quizcont').hide();
	    					 console.log(thisslide)
	    					 var input = thisslide.find('input');

	    					 // SLIDE 13
	    					 if (i == 13) {
	    					 	console.info("Slide 12");
	    					 	$('.quizcont').hide();
	    					 	$('#contactFormSubmit').addClass('is-active');
	    					 	$('.quizcont').hide();
	    					 }
	    					 else {
	    					 	$('#contactFormSubmit').removeClass('is-active');
	    					 	$('.quizcont').show();

	    					 		input.on('click', function() {
	    					 				$('.quizcont').css('visibility', 'visible');
	    					 		});

	    					 }


	    					 // ADD CONT BUTTON IF CHECKED



	    					 		if (input.is(':checked')) {
	    					 			console.info("im checked");
	    					 			$('.quizcont').css('display', 'flex').css('visibility', 'visible');
	    					 		}
	    					 		else {
	    					 			$('.quizcont').css('visibility', 'hidden');
	    					 		}




	});

	// Count Slides
	$slidecnt = 1;
	$('.quizbars .col').each(function(index, el) {
		var index = $slidecnt + index;
			$(this).attr('data-slidebar', index);
	});


	// CAROL

	$('.quizcarol').slick({
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: false,
	  	dots: false,
	  	draggable: false,
	  	adaptiveHeight: true,
	  	infinite:false,
	  	swipe:false,
	  	swipeToSlide:false,
	  	touchMove:false,
	});



	// // REQUIRE TO CONTINUE
	// $('.slick-slide').each(function() {
	// 	inputs = $(this).find('input');
	// 	textarea = $(this).find('textarea');
	// 	inputs.on('click', function(event) {
	// 		$('.quizcont').css('display', 'flex');
	// 	});
	// 	textarea.on('click', function(event) {
	// 		$('.quizcont').css('display', 'flex');
	// 	});
	// });


	// NEXT
	$('.quizcont').click(function(event) {
			event.preventDefault();
			$('.quizcarol').slick('slickNext');
			setTimeout(function() {
			$(this).hide();
			}, 200);
	});
	// PREV
	$('.quizback').not($('.quizback.exitbutton')).click(function(event) {
			event.preventDefault();
			$('.quizcarol').slick('slickPrev');
	});



	// SELECT ALL COMPILE FOR SHOPIFY LACK OF ARRAY
	// SUBMIT FORM /////////////////////

	$('#contactFormSubmit').click(function(event) {

		event.preventDefault();

		var input_array = new Array();
		$('#quizForm input:checkbox[name="contact[help_skin]"]:checked').each(function(){
		    input_array.push(' '+$(this).val()+' ');
		    			console.log($(this).val());
		});
		$('.help_skin_input').val(input_array);


		var concerns_array  = new Array();
		$('#quizForm input:checkbox[name="contact[What are your top two skincare concerns?]"]:checked').each(function(){
		    concerns_array.push(' '+$(this).val()+' ');
		    			console.log($(this).val());
		});
		$('.skin_concerns_input').val(concerns_array);


		var $form =	$('#quizForm');
		// can we hook it into mc




		 var emailaddy = $('input[name="contact[email]"]');
		 			var cloneemail = emailaddy.clone();
		 					cloneemail.insertAfter(emailaddy);
		 					cloneemail.attr('name', 'EMAIL').addClass('ismcEmail').hide();

		  var fname = $('input[name="contact[firstname]"]');
		  var clonefname = fname.clone();
		 		clonefname.insertAfter(fname);
		 		clonefname.attr('name', 'FNAME').hide();

		 		register($form);

		function register($form) {
				  $.ajax({
				    type: 'get',
				    url: 'https://skinstoreps.us4.list-manage.com/subscribe/post-json?u=844bd2ea54bccca150801b828&amp;id=0ca8ea6c51&c=?',
				    data: $form.serialize(),
				    cache: false,
				    dataType: 'json',
				    contentType: 'application/json; charset=utf-8',
				    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
				    success: function (data) {
				      if (data.result === 'success') {
				        // Yeahhhh Success
				        console.log(data.msg)
				        $('input[name="FNAME"]').remove();
				        $('input[name="EMAIL"]').remove();
				      } else {
				        // Something went wrong, do something to notify the user.
				        console.log(data.msg)
				        $('input[name="FNAME"]').remove();
				        $('input[name="EMAIL"]').remove();
				      }
				    },
				    complete: function(){

				    	 	 console.log("i am completed")
				    	 	 $form.submit();
				    }
				  });
				};





	});




	// RANGE SLIDER
 $(".js-range-slider").ionRangeSlider({
 	type: "single",
 	        min: 1,
 	        max: 10,
 	        from: 1,
 	        values: [1,2,3,4,5,6,7,8,9,10],
 	        grid: true,
 	        skin: "big",
 	        hide_min_max: true,
 	        onChange: function (data) {
          	console.log(data.from_value);

          	$('.irs-grid .irs-grid-text').each(function() {
          			var currentrange = $(this).html();
          			if (currentrange == data.from_value) {
          				$(this).css('color', '#3f4241');
          			}
          			else {
          				$(this).css('color', '#bdb9b6');
          			}
          	});

          	$('.quiz-wrap button.quizcont').css('visibility', 'visible');

        }
 });






/***********************************************
* Limit number of checked checkboxes script- by JavaScript Kit (www.javascriptkit.com)
* This notice must stay intact for usage
* Visit JavaScript Kit at http://www.javascriptkit.com/ for this script and 100s more
***********************************************/

function checkboxlimit(checkgroup, limit){
	var checkgroup=checkgroup
	var limit=limit
	for (var i=0; i<checkgroup.length; i++){
		checkgroup[i].onclick=function(){
		var checkedcount=0
		for (var i=0; i<checkgroup.length; i++)
			checkedcount+=(checkgroup[i].checked)? 1 : 0
		if (checkedcount>limit){
			// alert("You can only select a maximum of "+limit+" checkboxes")

			$('#chooseonlytwo').html("<span style='color:tomato;'>Please Choose Only Two</span>");
			this.checked=false
			}
			else {
				$('#chooseonlytwo').html("");
			}
		}
	}
}

var checkfortwo = $('.choose-two input');
checkboxlimit(checkfortwo, 2)



});